/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdraftrestored2Inputs */

const en_eventdraftrestored2 = /** @type {(inputs: Eventdraftrestored2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft restored`)
};

const de_eventdraftrestored2 = /** @type {(inputs: Eventdraftrestored2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf wiederhergestellt`)
};

/**
* | output |
* | --- |
* | "Draft restored" |
*
* @param {Eventdraftrestored2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdraftrestored2 = /** @type {((inputs?: Eventdraftrestored2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdraftrestored2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdraftrestored2(inputs)
	return de_eventdraftrestored2(inputs)
});
export { eventdraftrestored2 as "eventDraftRestored" }